export default __webpack_public_path__ + "static/media/5.950f79dd.png";